var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"primary",attrs:{"id":"download"},on:{"click":function($event){return _vm.downloadImage()}}},[_vm._v(".PNG"),_c('img',{attrs:{"src":require("../assets/img/icons/ic_download.svg")}})])]),_c('div',{attrs:{"id":"exportable"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }